import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Breadcrumbs } from "./Breadcrumbs";
import { getCategory } from "../lib/catalogueApi";
import { StoreLayout } from "./StoreLayout";
import { setPagedHead } from "./Paging";
import { useListing } from "./listing/useListing";
import { ListingView } from "./listing/ListingView";
import { HelpChooseButton } from "./assistant/HelpChooseButton";
import { NothingNow } from "./NothingNow";

export default function CategoryPage() {
  const { slug } = useParams();
  const L = useListing((params) => getCategory(slug, params), [slug]);
  const { data, loading, error } = L;
  useEffect(() => {
    if (!data) return;
    document.title = `${data.category.display_name} - Rhyte Step IT`;
    setPagedHead(data.canonical_path || `/c/${slug}`, data.page || 1, data.total_pages || 1, data.robots || "index,follow");
  }, [data, slug]);
  const name = data?.category?.display_name || "";
  const anc = data?.ancestors || [];
  return (
    <StoreLayout>
      <div className="mx-auto max-w-6xl px-5 py-8">
        {!loading && error && !data ? <div className="py-20 text-center text-slate-500" data-testid="category-notfound">Category not found.</div> : data?.empty ? <NothingNow what="category" name={name} testid="category-empty" /> : (<>
          <div className="mb-3 flex justify-end"><HelpChooseButton testid="category-help-choose" context={{ page: "category", category_slug: slug }} /></div>
          <ListingView L={L} prefix="category" title={(anc.length ? anc[anc.length - 1].name : name)} baseLabel={(name)}
            crumbs={<Breadcrumbs testid="category-breadcrumbs" className="mb-2" items={[{ to: "/products", label: "All products" }, ...anc.map((c) => ({ to: `/c/${c.slug}`, label: c.name }))]} />} />
        </>)}
      </div>
    </StoreLayout>
  );
}
